<template>
<v-container fluid grid-list-md>
  <!-- <div class="hidden-xs-only"><br><br></div> -->



  <v-layout row wrap>
    <v-flex v-bind:class="[bct?'md4':'text-md-right','fs'+fsize]" class="xs12 sm5 text-xs-center flexstuff">

      <slot name="ico"></slot>

    </v-flex>
    <v-flex v-bind:class="{'md8':bct}" class="xs12 sm7 vcenter">
      <slot/>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  name: "IconTable",
  data() {
    return {}
  },
  props: {
    "bct": {
      default: true
    },
    "fsize": {
      default: '200'
    }
  }
}
</script>
<style>
.flexstuff svg {
  position: sticky;
  top: 30px;
}

.flexstuff.fs200 svg {
  height:200px;
  width:200px;
}
.flexstuff.fs150 svg {
  height:150px;
  width:150px;
}
.flexstuff.fs100 svg {
  height:100px;
  width:100px;
}
.flexstuff.fs50 svg {
  height:50px;
  width:50px;
}

.vcenter{
  margin:auto;
  margin-left:0px;
  margin-right:0px;
}

/*  DEBUG
.flexstuff, .vcenter{
  border:1px solid black;
}
*/
</style>



// WEBPACK FOOTER //
// src/components/IconTable.vue